"use client";

import React from "react";

interface BodyCustomCode {
  code?: string;
}

export default function BodyCustomCode({ code }: BodyCustomCode) {
  React.useEffect(() => {
    const WRAPPER_ID = "body-custom-code-wrapper";
    const existingWrapper = document.getElementById(WRAPPER_ID);
    if (!code || existingWrapper) return;
    const wrapper = document.createElement("div");
    wrapper.id = WRAPPER_ID;
    const fragment = document.createRange().createContextualFragment(code);
    wrapper.appendChild(fragment);
    document.body.appendChild(wrapper);
  }, [code]);
  return null;
}
